type ToastType = 'successed' | 'failed';

export function showToast(content: string | HTMLElement, type: ToastType): void {
  const toastContainer = document.getElementById('toast-container');
  const toastTemplateWrapper = document.getElementById('toast-template');

  if (!toastContainer || !toastTemplateWrapper) {
    return;
  }

  const toastEl = document.createElement('div');
  toastEl.className = `toast align-items-center text-bg-${type} border-0 show mt-2`;
  toastEl.setAttribute('role', 'alert');
  toastEl.setAttribute('aria-live', 'assertive');
  toastEl.setAttribute('aria-atomic', 'true');

  const toastTemplate = toastTemplateWrapper.querySelector(
    `.toast-template.toast-template--${type}`,
  );

  const bodyWrapper = toastTemplate
    ? (toastTemplate.cloneNode(true) as HTMLDivElement)
    : document.createElement('div');

  if (!toastTemplate) {
    bodyWrapper.className = 'toast-body';
  }

  const toastTemplateTextInner = bodyWrapper.querySelector<HTMLElement>(`.toast-template__text`);

  if (!toastTemplate && typeof content === 'string') {
    bodyWrapper.innerText = content;
  } else if (!toastTemplate && typeof content !== 'string') {
    bodyWrapper.appendChild(content.cloneNode(true));
  } else if (toastTemplateTextInner && typeof content === 'string') {
    toastTemplateTextInner.innerText = content;
  } else if (toastTemplateTextInner && typeof content !== 'string') {
    toastTemplateTextInner.appendChild(content.cloneNode(true));
  }

  toastEl.appendChild(bodyWrapper);
  toastContainer.appendChild(toastEl);

  setTimeout(() => toastEl.remove(), 10000);
  toastEl.addEventListener('hidden.bs.toast', () => toastEl.remove());
}
